import { writable } from 'svelte/store';
import collect from 'collect.js';
import config from '@/config.js';
// Models
import MarketType from '@/Models/MarketType';
import SportStore from '@/Stores/Sport/SportStore';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	const methods = {
		getMarketTypesForSport(sportId, include = []) {
			if (!config.SPORT_ENABLED) return;

			const marketType = new MarketType();
			marketType.resourceUrl = () => {
				return `${marketType.baseUrl()}/sports/${sportId}/${marketType.resourceName()}`;
			};

			if (include) {
				marketType.with(include);
			}
			return marketType.get().then((result) => {
				set(result.data);
			});
		},

		createMarketType(data) {
			let marketType = new MarketType();

			return marketType
				.makePersistRequest({
					url: marketType.resourceUrl(),
					method: 'PUT',
					data
				})
				.then((result) => {
					SportStore.getSports(true);
					return result;
				});
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
